"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { dropdownCategoryConfig, DropdownCategoryType } from '../../shared.mjs';
import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import { ValueType } from '../../value-spec.mjs';
import { filterOptionsByLabel } from '../utils.mjs';
import { CUSTOM_OBJECT_VALUE, CUSTOM_OBJECT_VALUE_LABEL, CUSTOM_ARRAY_VALUE, CUSTOM_ARRAY_VALUE_LABEL } from './constants.mjs';

class CustomFieldOptionsFactory {
  async getOptions({ spec, input }) {
    const options = [];
    if (spec && (spec.type === ValueType.ANY || spec.type === ValueType.OBJECT)) {
      options.push({
        label: CUSTOM_OBJECT_VALUE_LABEL,
        value: CUSTOM_OBJECT_VALUE,
        iconType: SvgIconType.SchemaType_object
      });
    }
    if (spec && (spec.type === ValueType.ANY || spec.type === ValueType.ARRAY)) {
      options.push({
        label: CUSTOM_ARRAY_VALUE_LABEL,
        value: CUSTOM_ARRAY_VALUE,
        iconType: SvgIconType.SchemaType_array
      });
    }
    const result = filterOptionsByLabel(options, input);
    if (result.length > 0) {
      result.unshift({
        label: dropdownCategoryConfig[DropdownCategoryType.CUSTOM].title,
        isSection: true
      });
    }
    return result;
  }
}

export { CustomFieldOptionsFactory };
